import { cn } from "@/lib/utils";

import { getEntryStatusConfig } from "./entry-status";

type EntryStatusPillProps = {
  /** The `status` the API appends to the entry: a date, `delayed`, or null. */
  status: string | null | undefined;
  /** The maturity date of the entry, used to say how late it is. */
  maturity: string;
  now?: Date;
};

/**
 * A read-only pill. Paying an entry is an irreversible write, so it lives in
 * the row menu behind a confirmation, never under a click on the status cell.
 */
export function EntryStatusPill({ status, maturity, now }: EntryStatusPillProps) {
  const config = getEntryStatusConfig(status, maturity, now);

  return (
    <span
      data-status={config.kind}
      className={cn(
        "inline-flex items-center gap-2 whitespace-nowrap rounded-full border-l-[3px] px-2.5 py-1 text-xs font-medium tabular-nums",
        config.chip,
        config.edge
      )}
    >
      <span aria-hidden="true" className={cn("size-1.5 rounded-full", config.dot)} />
      {config.label}
    </span>
  );
}
